import { render, staticRenderFns } from "./levels-button.vue?vue&type=template&id=1136c934&"
import script from "./levels-button.vue?vue&type=script&lang=js&"
export * from "./levels-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports